import { Button, Card, Flex, Tabs, Typography } from 'antd';
import { useParams } from 'react-router';
import { ContainerOutlined } from '@ant-design/icons';

import CreditAccountTitle from './CreditAccountTitle';
import StatementsSection from './StatementsSection/StatementsSection';
import { CREDIT_ACCOUNT_VIEWS } from 'utilities/constants';
import config from 'config';

const ArchivedCreditAccountPage = () => {
  const { accountId } = useParams();
  return (
    <Card
      styles={{
        body: { padding: 'var(--spacing)' },
        header: {
          padding: '0 var(--spacing)',
        },
      }}
      title={
        <CreditAccountTitle
          extraContent={
            <Button
              size="small"
              variant="outlined"
              color="primary"
              onClick={(event) => {
                event.preventDefault();
                window.open(
                  `${config.SNOWFLAKE_STREAMLIT_URI}?streamlit-account_id=${accountId}`,
                  '_blank',
                );
              }}
            >
              View Historical Data
            </Button>
          }
        />
      }
    >
      <Flex
        vertical={true}
        align="center"
        justify="center"
        style={{ height: '60px' }}
      >
        <Typography.Title level={5} type="secondary">
          <ContainerOutlined style={{ marginRight: 'var(--spacing-xs)' }} />{' '}
          Account Archived
        </Typography.Title>
        <Typography.Text type="secondary" align="center">
          Information within Mission Control is limited.
        </Typography.Text>
      </Flex>
      <Tabs
        activeKey={CREDIT_ACCOUNT_VIEWS.STATEMENTS}
        defaultActiveKey={CREDIT_ACCOUNT_VIEWS.STATEMENTS}
        items={[
          {
            label: 'Statements',
            key: CREDIT_ACCOUNT_VIEWS.STATEMENTS,
            children: <StatementsSection />,
          },
        ]}
      />
    </Card>
  );
};

export default ArchivedCreditAccountPage;
